import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://rodrigoguzman83.github.io/my-portfolio'
      className='link footer__link'
    >
      Created By Luis Rodrigo Guzman
    </a>
  </footer>
)

export default Footer
